module.exports = __webpack_public_path__ + "img/product-preview-62.a5a613e.png";